<template>
    <div>
        <v-overlay :value="loading.data" opacity="0" z-index="4">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary">
            </v-progress-circular>
        </v-overlay>
        <v-card
            flat
            v-if="!loading.data">
            <v-card-title>
                {{ $t('TRUCK_TYPES_TITLE') }}
                <v-spacer></v-spacer>
                <v-text-field
                    append-icon="mdi-magnify"
                    :label="$t('TRUCK_TYPES_SEARCH')"
                    v-model="search"
                    hide-details
                    class="ml-4"
                ></v-text-field>
                <v-menu
                    offset-y>
                    <template v-slot:activator="{on}">
                        <v-btn
                            icon
                            v-on="on"
                            class="mx-1">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense >
                        <v-list-item
                            link
                            v-if="authorizations.truck_types.create"
                            @click="openTruckTypeDialog({editMode: false})"
                            >
                            <v-list-item-avatar>
                               <v-icon>mdi-plus-circle</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-title>
                                {{ $t('new_truck_type') }}
                            </v-list-item-title>
                        </v-list-item>
                         <v-list-item
                            v-if="authorizations.truck_types.update && selected.truckType.length == 1"
                            link
                            @click="openTruckTypeDialog({editMode: true, id: selected.truckType[0].id})"
                            :disabled="!selected.truckType[0].meta.editable">
                            <v-list-item-avatar>
                                <v-icon :disabled="!selected.truckType[0].meta.editable">mdi-pencil</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('ACTIONS_MENU_EDIT') }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                            v-if="authorizations.truck_types.delete && selected.truckType.length == 1"
                            link
                            @click="openDeleteDecisionDialog(selected.truckType[0].id)"
                            :disabled="!selected.truckType[0].meta.deletable">
                            <v-list-item-avatar>
                                <v-icon :disabled="!selected.truckType[0].meta.deletable">mdi-delete</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('ACTIONS_MENU_DELETE') }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                 </v-menu>
            </v-card-title>
            <v-card-subtitle>{{ $t('TRUCK_TYPES_REGISTER_SUBTITLE') }}</v-card-subtitle>
            <v-divider></v-divider>
            <v-card-text>
                <v-data-table
                    :headers="truckTypesHeaders"
                    dense
                    v-model="selected.truckType"
                    show-select
                    single-select
                    :items="truckTypes"
                    :search="search">
                </v-data-table>
            </v-card-text>
        </v-card>
        <TruckTypeDialog 
            ref="truckTypeDialog"
            @done="showAlert"
            />
        <AlertDialog 
            ref="alertDialog"
            />
        <DecisionDialog 
            ref="decisionDialog"
            @submit="submitDecisionDialog"
            />
    </div>
</template>

<script>
import TruckTypeDialog from '../components/TruckTypeDialog'
import AlertDialog from '../components/AlertDialog'
import DecisionDialog from '../components/DecisionDialog'
import { mapActions, mapState } from 'vuex';
export default {
    name: "TruckType",
    components: {
        TruckTypeDialog,
        AlertDialog,
        DecisionDialog
    },
    data() {
        return {
            truckTypesHeaders: [
                { text: this.$t('TRUCK_TYPES_NAME'), value: "name" }
            ],
            selected: {
                truckType: []
            },
            search: null,
            loading: {
                data: false
            }
        }
    },
    computed: {
        ...mapState("truckType", ["truckTypes"]),
        ...mapState("authentication", ["loggedInUser", "authorizations"])
    },
    methods: {
        ...mapActions("truckType", ["fetchTruckTypes", "removeTruckType"]),
        openTruckTypeDialog(params) {
            this.$refs.truckTypeDialog.open(params);
        },
        showAlert(message) {
            this.$refs.alertDialog.open(this.$t('ALERT_TITLE_WARNING'), message);
        },
        openDeleteDecisionDialog(id) {
            this.$refs.decisionDialog.open({
                title: this.$t('DELETE_CONFIRM_TITLE'),
                content: this.$t('DELETE_CONFIRM_CONTENT'),
                action: "DELETE",
                id: id
            });
        },
        submitDecisionDialog(payload) {
            if(payload.action == "DELETE") {
                this.removeTruckType(payload.id)
                    .then(response => {
                        this.$refs.alertDialog.open(this.$t('SUCCESS_TITLE'), response.message);
                        this.fetchTruckTypes();
                    })
                    .catch(error => {
                        this.$refs.alertDialog.open(this.$t('ERROR_TITLE'), error.message);
                    })
            }
        }
    },
    async created() {
        this.loading.data = true;
        await this.fetchTruckTypes();
        this.loading.data = false;
    }
}
</script>